import { useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider, defer } from "react-router-dom";
import { RestAPI } from "@aws-amplify/api-rest";

import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.css";
import { LayoutProvider } from "./layout/context/layoutcontext.js";
import Layout from "./layout/layout.js";
import "./styles/layout/layout.scss";
import MapError from "./pages/Map/MapError.js";

import Login from "./pages/Login/Login.js";
import AppWithAuthenticator from "./AuthWrapper/AppWithAuthenticator.jsx";

import Map from "./pages/Map/Map.js";

const delayms = 2500;

const getRouter = () => createBrowserRouter([
    {
        element: <Layout />,
        children: [
            {
                path: "/",
                element: <Map />,
                loader: async () => {
                    const delay = new Promise((resolve) => setTimeout(resolve, delayms));
                    const apiPromise = RestAPI.get("apiApplication", "/farms");
                    return defer({
                        farms: Promise.all([apiPromise, delay]).then(([apiResult]) => apiResult)
                    });
                },
                errorElement:(<MapError />),
                children: []
            }
        ]
    }
]);

function App() {
    // loader functions will be called inmediatly when createBrowserRouter is called, if the route is correct
    // to prevent failing because we have no auth-data, defer the router creation to the mounting of the app component
    const [routerInfo, setRouterInfo] = useState({ router: null, idx: 0 });

    useEffect(() => {
        const router = getRouter();
        setRouterInfo((ri) => ({ router, idx: (ri.idx + 1) }));

        // we need to clear the memory of the previous router
        return () => router.dispose();
    }, []);

    if (!routerInfo.router) return null;
    return (
        <RouterProvider
            key={routerInfo.idx} router={routerInfo.router} fallbackElement={
                <div>
                    ...
                </div>
            }
        />
    );
}

export default function AppWithLayout() {
    return (
        <AppWithAuthenticator>
            {({ auth, ...props }) => (
                <LayoutProvider auth={auth}>
                    {auth ? <App /> : <Login {...props} />}
                </LayoutProvider>

            )}
        </AppWithAuthenticator>
    );
}
